import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Footer from "../../../components/_App/Footer";
import Navbar from "../../../components/_App/Navbar1";
import PageBanner from "../../../components/Common/PageBanner";
import Link from "next/link";
import Head from "next/head";

const Months = ({ months, dataNav }) => {
  // console.log("this is static months data from slug:", months);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [tabUrl, setTabUrl] = useState(null);
  const [images, setImages] = useState(null);

  useEffect(() => {
    setTabUrl(window.location.href);
    setImages(document.images[0].src);
  }, []);

  // let path = "/blog/";

  // months &&
  //   months.paths &&
  //   months.paths.map((item) => {
  //     path = path + item.slug + "/";
  //   });

  const viewInsideResource = (item) => {
    setSelectedResource(null);
    setModalIsOpen(true);
    setSelectedResource(item);
  };

  const Resources = () => {
    return (
      <div className="view-resoures-modal-wrapper">
        <h4 className="text-2xl text-black font-bold w-100 text-center mb-4">
          {selectedResource && selectedResource.name}
        </h4>
        <div>
          {selectedResource &&
            selectedResource.resources.map((item1) => (
              <>
                <div className="modal-card-wrapper">
                  <div className="modal-card-inner">
                    <div className="card-image-wrapper">
                      <img
                        src={item1 && item1.image}
                        alt={selectedResource.offering_slug}
                      />
                    </div>
                    <div className="file-name">
                      <h4 className="sm:text-2xl text-base text-black font-bold ">
                        {selectedResource.name} -{" "}
                        {item1 && item1.lang === "en" ? (
                          <>English Version</>
                        ) : item1 && item1.lang === "hi" ? (
                          <>हिंदी Version</>
                        ) : (
                          <>English / हिंदी Version</>
                        )}
                      </h4>
                      <button
                        type="button"
                        disabled="true"
                        className="btn-style mt-3 btn text-white sm:text-xl text-sm font-medium bg-blue"
                      >
                        {item1 && item1.lang === "en" ? (
                          <>English</>
                        ) : item1 && item1.lang === "hi" ? (
                          <>हिंदी</>
                        ) : (
                          <>English / हिंदी</>
                        )}
                      </button>
                    </div>
                    <a href={item1.file_name} className="download-btn-wrapper">
                      <img src="/images/download.svg" alt="download pdf" />
                      <p>Download PDF</p>
                    </a>
                  </div>
                </div>
                {/* <div className="modal-card-wrapper">
                <div className="modal-card-inner">
                  <div className="card-image-wrapper">
                    <img src="/images/health-services-bg.jpg" alt="" />
                  </div>
                  <div className="file-name">
                    <h4 className="sm:text-2xl text-base text-black font-bold ">
                      CA360 April 2022 - English Version
                    </h4>
                    <button
                      type="button"
                      className="btn-style mt-3 btn text-white sm:text-xl text-sm font-medium bg-orange"
                    >
                      हिंदी
                    </button>
                  </div>
                  <div className="download-btn-wrapper">
                    <img src="/images/download.svg" alt="download pdf" />
                    <p>Download PDF</p>
                  </div>
                </div>
              </div> */}
              </>
            ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle={months && months.paths[1].name}
        homePageUrl="/"
        homePageText="Home"
        activePageText={
          months &&
          months.paths.map((path, index) => {
            const i = months.paths.length - 1;
            return (
              <>
                {index == 0 ? (
                  <Link href="/current-affairs/">
                    <a>{path.name}</a>
                  </Link>
                ) : index == 1 ? (
                  <Link href={`/current-affairs/${path.slug}`}>
                    <a>{path.name}</a>
                  </Link>
                ) : (
                  <Link href="#">
                    <a>{path.name}</a>
                  </Link>
                )}
                {index !== i && " / "}
              </>
            );
          })
        }
      />

      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <title>Download the {months && months.paths[1].name} resources</title>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta
            property="og:title"
            content={`Download the ${months && months.paths[1].name} resources`}
          />
          <meta
            name="description"
            content={`Save your most valuable time and prepare of the latest updated current affairs on ${
              months && months.paths[1].name
            } with ToppersNotes`}
          />
          <meta
            property="og:description"
            content={`Save your most valuable time and prepare of the latest updated current affairs on ${
              months && months.paths[1].name
            } with ToppersNotes`}
            key="description"
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <meta property="og:image" content={images} />
          <link
            rel="canonical"
            // property="og:title"
            // content={seotitle}
            // key="title"
            href={tabUrl}
          ></link>
        </Head>
      </div>
      <div>
        <div className="container">
          <div className="row my-8">
            {months && months.data && months.data.map
              ? months.data.map((item) => {
                  return (
                    // <Link href={`../resources/${item.slug}`}>
                    <>
                      {item && item.has_resources && item.resources.length ? (
                        <>
                          <div className="col-lg-4 col-sm-6 col-md-6 text-center mb-10">
                            <a className="link-btn">
                              <div className="content max-w-xs mx-auto affairs-box rounded-lg">
                                <div className="px-3 py-6">
                                  <h6 className="font-bold text-xl">
                                    {item && item.name}
                                  </h6>
                                  <div className="text-sm font-medium resources-color">
                                    {/* {item && item.offering_slug}{" "} */}
                                    {item.has_resources &&
                                    item.resources.length ? (
                                      <>
                                        <div>
                                          <b>{item.resources.length}</b>{" "}
                                          Resoures
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div>
                                          {item.resources.length} Resoures
                                        </div>
                                      </>
                                    )}
                                    {item.resources &&
                                    item.resources.length === 1 ? (
                                      <a
                                        className="download-pdf-btn"
                                        href={item.resources[0].file_name}
                                      >
                                        <img
                                          src="/images/download.svg"
                                          alt="download pdf"
                                        />
                                        Download PDF
                                      </a>
                                    ) : item.resources &&
                                      item.resources.length === 2 ? (
                                      <a
                                        className="download-pdf-btn p-3 all-resources-btn"
                                        onClick={() => viewInsideResource(item)}
                                      >
                                        <img
                                          src="/images/viewAllResources.svg"
                                          alt="download pdf"
                                        />
                                        View All Resources
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </>
                      ) : null}
                    </>
                    // </Link>

                    // <>
                    //   {monthss.has_subdirectories ? (
                    //     <Link href={`../resources/${monthss.slug}`}>
                    //       <div className="col-lg-4 col-sm-6 col-md-6 p-6 text-center">
                    //         <a className="link-btn">
                    //           <div className="content p-6 max-w-xs bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    //             <div className="p-2">
                    //               <h3 className="font-bold">{monthss.name}</h3>
                    //               <span className="text-sm">
                    //                 {monthss.offering_slug}{" "}
                    //                 {monthss.resources.length} Resources
                    //               </span>
                    //             </div>
                    //           </div>
                    //         </a>
                    //       </div>
                    //     </Link>
                    //   ) : (
                    //     <div>
                    //       {monthss &&
                    //         monthss.resources.map((re) => (
                    //           <Link href={`${re.file_name}`}>
                    //             <div className="col-lg-4 col-sm-6 col-md-6 p-6 text-center">
                    //               <a className="link-btn">
                    //                 <div className="content p-6 max-w-xs bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    //                   <div className="p-2">
                    //                     <h3 className="font-bold">
                    //                       {monthss.name}
                    //                     </h3>
                    //                     <span className="text-sm">
                    //                       {monthss.resources.length} Resources
                    //                     </span>
                    //                   </div>
                    //                 </div>
                    //               </a>
                    //             </div>
                    //           </Link>
                    //         ))}
                    //     </div>
                    //   )}
                    // </>
                  );
                })
              : "Loading"}
          </div>
        </div>
      </div>
      <Footer />
      <div className="view-all-resources-modal">
        <Modal
          className="view-all-resources-inner"
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          // style={customStyles}
          contentLabel="OTP Modal"
          aria-labelledby="contained-modal-title-vcenter"
          shouldCloseOnOverlayClick={false}
        >
          <button
            className="close-popup-btn"
            onClick={() => setModalIsOpen(false)}
          >
            X
          </button>
          <Resources />
        </Modal>
      </div>
    </>
  );
};

export default Months;

export const getStaticPaths = async () => {
  // const res = await fetch(
  //   `https://api.toppersnotes.com/api/ca/get-offering-directories?offering_slug=daily-current-affairs`
  // );
  // const offering = await res.json();
  // const paths = offering.data.map((offer) => ({
  //   params: { slug: offer.slug.toString() },
  // }));

  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async (context) => {
  const slug = context.params.slug;
  const res = await fetch(
    `https://api.toppersnotes.com/api/ca/get-offering-directories?offering_slug=daily-current-affairs&directory_slug=${slug}`
  );

  const months = await res.json();
  if (!months) {
    return {
      notFound: true,
    };
  }
  return {
    props: { months },
    revalidate: 86400,
  };
};
